import { Dialog } from 'primereact/dialog';

const CotizacionesDialog = ({ visible, onHide }) => {
    return (
        <Dialog 
            header="Detalles de Cotizaciones" 
            visible={visible} 
            className="p-fluid custom-dialog"
            onHide={onHide}
        >
            <div className="grid">
                <div className="col-12 md:col-6">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Generadas</div>
                        <div className="text-md text-gray-500 mb-2">del 02/10/2025 al 02/01/2026</div>
                        <div className="text-4xl text-blue-500 font-bold">2</div>
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="surface-0 p-3 border-round shadow-1 h-full">
                        <div className="text-xl font-bold mb-3">Última cotización</div>
                        <div className="text-4xl text-green-500 font-bold">11:20</div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default CotizacionesDialog;